import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: document.body.dataset.sentryDsn,
  environment: document.body.dataset.sentryEnvironment,
  release: document.body.dataset.sentryRelease,

  integrations: [Sentry.browserTracingIntegration()],

  tracesSampleRate: 0.2,
});
